<template>
  <div class="mt__main">
    <div class="mt__center">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新闻资讯</el-breadcrumb-item>
      </el-breadcrumb>
      <br>
      <el-card class="mt__card" :body-style="{  }" shadow="never">
        <div v-for="news in newsData" :key="news['标题']" @click="newsLink(news['详情链接'])">
          <div class="mt__content--table">
            <div class="mt__content--main">
              <div>
                <img :src="news['图片路径']" width="150">
              </div>
              <div>
                <span>{{ news['发布时间'] }}</span>
                <h3 style="text-align: left;margin-top: 0;">{{ news['标题'] }}</h3>
                <p>{{ news['描述'] }}</p>
              </div>
            </div>
          </div>
          <hr>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import newsImage from "../assets/news/news.png";

export default {
  name: "news",
  data() {
    return {
      newsData: []
    };
  },
  created() {},
  mounted() {
    let that = this;
    this.$http
      .post("/mtex/mtplat/portal/queryNews")
      .then(function(response) {
        that.newsData = response.data.result.data;
        for (const news of that.newsData) {
          if (news["图片路径"] == null) {
            news["图片路径"] = newsImage;
          }
        }
      })
      .catch(function(err) {
        console.log(err);
      });
  },
  updated() {},
  methods: {
    newsLink(url) {
      if (url) {
        window.open(url);
      }
    }
  }
};
</script>

<style scoped>
.mt__main {
  background-color: #f5f5f5;
}
.mt__main > .mt__center {
  padding: 20px 0;
}

.mt__content--table {
  cursor: pointer;
}

.mt__content--main img {
  margin-right: 20px;
}
.mt__content--main span {
  float: right;
}
hr {
  margin: 30px 0;
}
span {
  color: #808080;
}
.mt__content--main > div:first-child {
  width: 170px;
}
</style>



// WEBPACK FOOTER //
// src/components/news.vue